<template>
    <base-modal
        title="Eliminar ruta"
        size="sm"
        :confirm-text="isDeleting ? 'Eliminando...' : 'Eliminar ruta'"
        :confirm-disabled="isDeleting"
        @close="close"
        @confirm="deleteRoute"
    >
        ¿Desea eliminar la ruta {{ route.name }}?
    </base-modal>
</template>

<script>
import BaseModal from './BaseModal.vue';

export default {
    name: 'ModalDeleteRoute',
    components: { BaseModal },
    props: {
        route: { type: Object, required: true },
        url: { type: String, required: true }
    },
    data() {
        return {
            isDeleting: false
        };
    },
    methods: {
        close() {
            this.$emit('close');
        },
        async deleteRoute() {
            try {
                this.isDeleting = true;
                const { data } = await axios.delete(`${this.url}/${this.route.uuid}`);
                
                this.close();
                
                await this.$nextTick();
                
                await this.$swal({
                    icon: 'success',
                    title: 'Éxito',
                    text: data.message || 'Ruta eliminada correctamente',
                    confirmButtonText: 'Aceptar'
                });
                
                this.$emit('reloadtable');
            } catch (error) {
                console.error('Error al eliminar ruta:', error);
                
                this.close();
                
                await this.$nextTick();
                
                await this.$swal({
                    icon: 'error',
                    title: 'Error',
                    text: error.response?.data?.message || 'No se pudo eliminar la ruta',
                    confirmButtonText: 'Aceptar'
                });
            }
        }
    }
};
</script>
